function getIndicesOf(pattern_, text_, caseSensitive = false) {
  let text = text_;
  let pattern = pattern_;
  const queryLength = pattern.length;
  if (queryLength === 0) return [];
  let startIndex = 0;
  const indices = [];
  if (!caseSensitive) {
    text = text.toLowerCase();
    pattern = pattern.toLowerCase();
  }
  let index = text.indexOf(pattern, startIndex);
  while (index > -1) {
    indices.push(index);
    startIndex = index + queryLength;
    index = text.indexOf(pattern, startIndex);
  }
  return indices;
}
export {
  getIndicesOf
};
//# sourceMappingURL=getIndicesOf.js.map
